import "!../../node_modules/mini-css-extract-plugin/dist/loader.js?{}!css-loader?{\"modules\":false,\"url\":false}!./input.treat.1hWlZfy.css";
export var inputStyle = {base:'_2fLMd',withErrors:'_2f2gc'};
export var readonlyInputStyle = '_12CUR';